import { createFileRoute } from "@tanstack/react-router";
import { AddPrinterPage } from "../features/printers/add-printer";
import { Require } from "../features/require";

/** More > Printers > Add printer (P5-T24). */
export const Route = createFileRoute("/more/printers/new")({ component: Page });

function Page() {
	return (
		<Require permission="printers.manage">
			<AddPrinterPage />
		</Require>
	);
}
